import { z } from 'zod/v4';
import { CachedPreviewQueryDTO, CachedQueryDTO } from './cached-query';
import { DSLSearchRequestDTO } from '@/shared/api/opensearch';

export const OpensearchQueryDTO = CachedQueryDTO.pick({
  tab_id: true,
  widget_id: true,
  ci_ids: true,
  advanced_tql_params: true,
  variable_values: true,
}).extend({
  dsl: DSLSearchRequestDTO(),
  use_pit: z.boolean().default(false).optional(),
});

export type OpensearchQuery = z.infer<typeof OpensearchQueryDTO>;

export const OpensearchPreviewQueryDTO = CachedPreviewQueryDTO.pick({
  ci_ids: true,
  advanced_tql_params: true,
}).extend({
  dsl: DSLSearchRequestDTO(),
  use_pit: z.boolean().default(false).optional(),
});

export type OpensearchPreviewQuery = z.infer<typeof OpensearchPreviewQueryDTO>;